import { InitPage } from "../index";
import axios from "axios";

declare var cociCatalogItemParts: string;
declare let catalogItemsObj: any;

class CatalogItems {
  init() {
    const _self = this;
    $(".coci-view-btn").on("click", function () {
      $("#cociItemPartName").val("");
      $("#cociItemPartCount").val("");
      const item_number = $(this).data("number");
      $("#cociItemPartNumber").val(item_number);
      const item_name = $(this).data("name");
      $("#cociItemName").html(item_name);
      _self.loadItemParts(item_number);
      $("#manageCOCIItemParts").modal("show");
    });

    $("#cociItemPartCreateBtn").on("click", function () {
      _self.createItemPart();
    });
  }

  createItemPart() {
    if (!$("#cociItemPartName").val() || !$("#cociItemPartCount").val()) {
      window.toastr_notifications.error(
        "The part details and count values are required!",
        "Error",
      );
      return;
    }
    var formDataArray = $("#createItemPartForm").serializeArray();
    var formDataObject = this.arrayToObject(formDataArray);
    var formDataJSON = JSON.stringify(formDataObject);
    const item_number = $("#cociItemPartNumber").val();
    const _self = this;
    axios
      .post(
        `${cociCatalogItemParts}/${item_number}/coci/catalog_item_parts`,
        formDataJSON,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      )
      .then(function (response) {
        window.toastr_notifications.success(
          "Item part created successfully!",
          "Success",
        );
        _self.loadItemParts(item_number);
        $("#cociItemPartName").val("");
        $("#cociItemPartCount").val("");
      })
      .catch(function (error) {
        window.toastr_notifications.error(error.response.data.error, "Error");
      });
  }

  removeItemPart(id) {
    const item_number = $("#cociItemPartNumber").val();
    const _self = this;
    axios
      .delete(
        `${cociCatalogItemParts}/${item_number}/coci/catalog_item_parts/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      )
      .then(function (response) {
        window.toastr_notifications.success(
          "Item part deleted successfully!",
          "Success",
        );
        _self.loadItemParts(item_number);
      })
      .catch(function (error) {
        window.toastr_notifications.error(error.response.data.error, "Error");
      });
  }

  loadItemParts(item_number) {
    axios
      .get(`${cociCatalogItemParts}/${item_number}/coci/catalog_item_parts`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        const item_parts = response.data.catalog_item_parts;
        const tbody = $("#cociItemPartsTBody");
        tbody.html("");
        var i = 1;
        item_parts.forEach((part) => {
          const row = document.createElement("tr");
          row.classList.add("center-content");
          row.innerHTML = `
                    <tr class='center-content'>
                    <td>${i}</td>
                    <td style='text-align: left !important; width: 70%'>${part.part_name}</td>
                    <td> ${part.part_count} </td>
                    <td class='small-space sn-icons'>
                      <a href='#', class="fa fa-minus-circle fa-2x circle-delete-icon deleteRecord" title='Delete' 'data-toggle'='tooltip' onclick="catalogItemsObj.removeItemPart(${part.id})"></a>
                    </td>
                    </tr>`;
          tbody.append(row);
          i = i + 1;
        });
      })
      .catch(function (error) {
        window.toastr_notifications.error(error.response.data.error, "Error");
      });
  }

  arrayToObject(array) {
    var result = {};
    array.forEach(function (item) {
      var keys = item.name.split("[");
      var currentObj = result;
      keys.forEach(function (key, index) {
        key = key.replace("]", "");
        if (index === keys.length - 1) {
          currentObj[key] = item.value;
        } else {
          currentObj[key] = currentObj[key] || {};
          currentObj = currentObj[key];
        }
      });
    });

    return result;
  }
}

export function LoadPage() {
  InitPage("items", () => {
    const catalogItems = new CatalogItems();
    catalogItems.init();
  });
}

(window as any).catalogItemsObj = new CatalogItems();
